import { FetchEventSourceInit, fetchEventSource } from '@microsoft/fetch-event-source';
import { getAuthToken, redirectToLogin } from './auth0Client';

// 全局权限弹框状态管理
let setGetFullAccessModalOpen: ((value: boolean) => void) | null = null;

// 设置权限弹框状态管理函数
export function setSsePermissionHandler(handler: (value: boolean) => void) {
    setGetFullAccessModalOpen = handler;
}

export async function sseFetch(url: string, options: FetchEventSourceInit = {}): Promise<void> {
	try {
        const token = await getAuthToken();
        if (token) {
            options.headers = {
                ...options.headers,
                'Authorization': `Bearer ${token}`,
            };
        }
    } catch (error) {
        console.error('Error retrieving token:', error);
        redirectToLogin();
    }

    const modifiedOptions: FetchEventSourceInit = {
        ...options,
        async onopen(response) {
            if (response.ok && response.headers.get('content-type')?.includes('text/event-stream')) {
                if (options.onopen) {
                    options.onopen(response);
                }
            } else if (response.status === 403) {
                // 处理403权限错误
                try {
                    // 克隆响应以避免消费原始流
                    const clonedResponse = response.clone();
                    const json = await clonedResponse.json();
                    const action_required = json?.action_required;
                    
                    if (action_required === 'start_trial_or_upgrade' || action_required === 'upgrade') {
                        // 检查当前路由是否为编辑页面
                        const currentPath = window.location.pathname;
                        const isEditPage = currentPath === '/edit' || currentPath.startsWith('/edit/');

                        // 只在编辑页面触发全局权限弹框
                        if (isEditPage && setGetFullAccessModalOpen) {
                            console.log('SSE action_required', action_required);
                            setGetFullAccessModalOpen(true);
                        }
                    }
                } catch (parseError) {
                    console.error('Error parsing 403 response:', parseError);
                }
                
                // 对于权限错误，直接终止SSE连接
                return;
            } else {
                // 克隆响应以避免消费原始流
                const clonedResponse = response.clone();
                const json = await clonedResponse.json();
                const message = json.message || json.error || json.err || JSON.stringify(json);
                throw new Error(message);
            }
        },
        onerror(err) {
            if (options.onerror) {
                options.onerror(err);
            }
        }
    };

	return await fetchEventSource(url, modifiedOptions);
}